export enum TOAST_TYPE {
  CONNECTION = 'connection',
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export enum TOAST_CONTEXT {
  CONNECTION = 'connection',
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
}
